// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TreeSvg from '@rsuite/icon-font/lib/file/Tree';
var Tree = createSvgIcon({
  as: TreeSvg,
  ariaLabel: 'tree',
  category: 'file',
  displayName: 'Tree'
});
export default Tree;